module.exports = __webpack_public_path__ + "static/img/img6.4e5aa5e1.png";